import React from "react";
import { useParams } from "react-router-dom";
import ArticleView from "../components/ArticleView";
import { specialismCodeMap, SpecialismCode } from "../contexts/SpecialismContext";

const Article: React.FC<{ specialismCode: SpecialismCode }> = ({ specialismCode }) => {
  const { id } = useParams<{ id: string }>();
  const specialism = specialismCodeMap[specialismCode];

  // If the code is invalid, fallback to nothing (should be handled by App.tsx route check)
  if (!specialism) return null;

  return <ArticleView articleId={id} specialism={specialism} />;
};

export default Article;